export const fantissimaCalendarEvents = () => {
  const nextButton = document.querySelector('button[data-js-fantissima-next]')
  const prevButton = document.querySelector('button[data-js-fantissima-prev]')
  const list = document.querySelector('ol[data-js-fantissima-days]')
  const calendar = list.closest('[data-js-calendar]')
  const categoryLegend = calendar.querySelector('[data-js-category-legend]')
  const goToNextMonth = calendar.querySelector('[data-js-go-to-next-month]')
  const items = list.querySelectorAll('li.availability-calendar__day')
  const monthEndClass = 'fantissima-calendar__canvas--end'
  const liCount = items.length
  const canvas = list.parentElement
  const slideToShow = 7
  let currentIndex = 0
  const itemsMargin = 10
  const transitionDelayMultiplier = 0.1
  const dayActiveClass = 'availability-calendar__day--active'
  const dayPrevClass = 'availability-calendar__day--prev'
  const dayNextClass = 'availability-calendar__day--next'

  prevButton.setAttribute('disabled', 'disabled')

  // get all item heights for dynamic height calculation
  const updateItemHeights = () =>
    Array.from(items).map(item => item.offsetHeight)

  // calculate canvas height based on visible items
  const getCanvasHeight = () => {
    const end = Math.min(currentIndex + slideToShow + 1, liCount)
    let canvasHeight = 0
    for (let i = currentIndex; i < end; i++) {
      canvasHeight += itemHeights[i] + itemsMargin
    }
    canvasHeight = canvasHeight - itemsMargin + 13
    return canvasHeight
  }

  // set canvas height
  const updateCanvasHeight = height => {
    canvas.style.height = height + 'px'
  }

  // calculate height of currently visible items
  const getIndexHeight = () => {
    const end = Math.min(currentIndex + slideToShow, liCount)
    let indexHeight = 0
    for (let i = currentIndex; i < end; i++) {
      indexHeight += itemHeights[i] + itemsMargin
    }
    return indexHeight
  }

  // get height of all previous items for translateY calculation
  const getPreviousItemsHeight = () => {
    let previousItemsHeight = 0
    for (let i = currentIndex - 1; i >= 0; i--) {
      items[i].style.transform = 'none'
      previousItemsHeight += itemHeights[i] + itemsMargin
      items[i].removeAttribute('style')
    }
    return previousItemsHeight
  }

  let itemHeights = updateItemHeights()
  let actualCanvasHeight = getCanvasHeight()
  updateCanvasHeight(actualCanvasHeight)
  let actualIndexHeight = getIndexHeight()
  let previousTranslateY = 0

  nextButton.addEventListener('click', () => {
    scrollList('down')
  })
  prevButton.addEventListener('click', () => {
    scrollList('up')
  })

  // Debounce resize event
  let resizeTimeout
  window.addEventListener('load', () => {
    itemHeights = updateItemHeights()
    updateCanvasHeight(getCanvasHeight())
  })

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(() => {
      itemHeights = updateItemHeights()
      actualCanvasHeight = getCanvasHeight()
      updateCanvasHeight(actualCanvasHeight)
      // reset translate value
      previousTranslateY = -getPreviousItemsHeight()
      list.style.transform = 'translateY(' + previousTranslateY + 'px)'
      actualIndexHeight = getIndexHeight()
    }, 100)
  })

  // disable next button if not enough items
  if (liCount <= slideToShow) {
    nextButton.setAttribute('disabled', 'disabled')
    canvas.classList.add(monthEndClass)
    if (goToNextMonth) {
      goToNextMonth.removeAttribute('hidden')
    }
  }

  // scroll calendar list up or down
  const scrollList = direction => {
    canvas.setAttribute('aria-busy', 'true')

    // hide all items first
    items.forEach(item => {
      const button = item.querySelector('button')
      item.setAttribute('aria-hidden', 'true')
      item.setAttribute('inert', 'inert')
      if (button) {
        button.setAttribute('tabindex', '-1')
      }
    })

    let transitionDelay

    if (direction === 'down') {
      currentIndex = Math.min(currentIndex + slideToShow, liCount - 1)
      previousTranslateY -= actualIndexHeight
      transitionDelay = transitionDelayMultiplier * slideToShow
    } else if (direction === 'up') {
      currentIndex = Math.max(currentIndex - slideToShow, 0)
      previousTranslateY += getIndexHeight()
      transitionDelay = transitionDelayMultiplier * -1
    }

    requestAnimationFrame(() => {
      list.style.transform = 'translateY(' + previousTranslateY + 'px)'
    })

    // set previous page classes and delays
    const endOfPreviousPage = Math.max(currentIndex - slideToShow - 1, 0)
    for (let i = currentIndex; i >= endOfPreviousPage; i--) {
      items[i].classList.remove(dayActiveClass)
      items[i].classList.add(dayPrevClass)
      items[i].style.transitionDelay = transitionDelay + 's'
      transitionDelay = direction === 'down' ? transitionDelay - transitionDelayMultiplier : transitionDelay + transitionDelayMultiplier
    }

    // set next page classes and delays
    const endOfNextPage = Math.min(currentIndex + slideToShow * 2 + 1, liCount)
    transitionDelay = direction === 'down' ? transitionDelayMultiplier * -1 : transitionDelayMultiplier * slideToShow
    for (let i = currentIndex; i < endOfNextPage; i++) {
      items[i].classList.remove(dayActiveClass)
      items[i].classList.add(dayNextClass)
      items[i].style.transitionDelay = transitionDelay + 's'
      transitionDelay = direction === 'down' ? transitionDelay + transitionDelayMultiplier : transitionDelay - transitionDelayMultiplier
    }

    // show actual page items
    const endOfActualPage = Math.min(currentIndex + slideToShow, liCount)
    for (let i = currentIndex; i < endOfActualPage; i++) {
      const button = items[i].querySelector('button')
      items[i].removeAttribute('aria-hidden')
      items[i].removeAttribute('inert')
      if (button) {
        button.removeAttribute('tabindex')
      }
    }

    // set active classes and delays
    const endOfActiveSlides = Math.min(currentIndex + slideToShow + 1, liCount)
    transitionDelay = direction === 'down' ? transitionDelayMultiplier * -1 : transitionDelayMultiplier * slideToShow

    // get all active slides (slideToShow + 1)
    for (let i = currentIndex; i < endOfActiveSlides; i++) {
      items[i].classList.add(dayActiveClass)
      items[i].classList.remove(dayPrevClass, dayNextClass)
      items[i].style.transitionDelay = transitionDelay + 's'
      transitionDelay = direction === 'down' ? transitionDelay + transitionDelayMultiplier : transitionDelay - transitionDelayMultiplier
    }

    prevButton.toggleAttribute('disabled', currentIndex === 0)
    nextButton.toggleAttribute('disabled', currentIndex >= liCount - slideToShow)
    canvas.classList.toggle(monthEndClass, currentIndex >= liCount - slideToShow)
    if (goToNextMonth) {
      goToNextMonth.toggleAttribute('hidden', currentIndex < liCount - slideToShow)
    }

    canvas.focus()
    categoryLegend.scrollIntoView({ behavior: 'smooth' })

    actualCanvasHeight = getCanvasHeight()
    updateCanvasHeight(actualCanvasHeight)
    actualIndexHeight = getIndexHeight()

    canvas.setAttribute('aria-busy', 'false')
  }

  // ensure calculations are done after DOM is fully loaded
  window.addEventListener('load', () => {
    actualCanvasHeight = getCanvasHeight()
    updateCanvasHeight(actualCanvasHeight)
    actualIndexHeight = getIndexHeight()
  })
}

fantissimaCalendarEvents()
